import React, { Component } from 'react';

class LearnToRide extends Component {
  componentDidMount() {
    document.title = 'Learn to Ride  | Flamingo Scooters';
  }

  // ----- Renders -----

  render() {
    // Main render
    return (
      <div className="fm-bike">
        <div className="fm-bike-header">
          <img className="fm-bike-header-background" alt="Flamingo Bike" src="https://storage.googleapis.com/flamingo-static/images/promo/promo-ltr20.jpg" />
        </div>
        <div className="fm-bike-content">
          <p className="fm-bike-instructions">Thanks for attending a Flamingo Learn to Ride!</p>
          <p className="fm-bike-instructions">20 minutes of free credit has been applied to your account.</p>
          <p className="fm-bike-term">Valid for 2 weeks. A $1 unlocking fee applies. This voucher has no cash value and cannot be exchanged or transferred.</p>
        </div>
      </div>
    );
  }
}

export default LearnToRide;
